import React from "react";
import params from "../Params";
import {PAYMENT_METHOD_ALIPAY, PAYMENT_METHOD_CREDIT_CARD} from "../Const";

class SimGps {

    constructor(url, api_key, id_token){
        this.url = url;

        this.req_headers = new Headers();
        this.req_headers.append('x-api-key', api_key);
        this.req_headers.append('Content-Type', 'application/json');
        this.req_headers.append('Authorization', id_token);

    }

    makeHttpRequest(init, url, onResult) {
        init.headers = this.req_headers;
        init.mode = 'cors';
        init.cache = 'default';

        fetch(url, init)
            .then(res => res.json())
            .then((result) => {
                    onResult(true, result);
                },
                (error) => {
                    console.log(JSON.stringify(error));
                    onResult(false, error);
                }
            );
    }

    doRequest(url, body, onResult, method="POST" ){
        const init = {
            method: method,
            body: JSON.stringify(body),
        };

        this.makeHttpRequest(init, this.url + '/' + url, onResult);
    }

    doGetRequest(url, queryParams, onResult ){
        const esc = encodeURIComponent;

        const query = Object.keys(queryParams)
            .map(k => esc(k) + '=' + esc(queryParams[k]))
            .join('&');

        if( query.length > 0 )
            url = url + '?' + query;

        const init = {
            method: 'GET',
        };

        this.makeHttpRequest(init, this.url + '/' + url, onResult);
    }

    getUserDevices( onResult ){
        this.doGetRequest('user_data/devices', {}, onResult );
    }

    getDevice(dev_uuid,  onResult ) {
        this.doGetRequest('user_data/device/' + dev_uuid, {}, onResult );
    }

    submitScenario(dev_uuid, scenario, onResult ){
        this.doRequest( 'user_data/device/' + dev_uuid + '/scenario',
            scenario,
            onResult
        );
    }

    getOrderList( onResult ){
        this.doGetRequest('payments/orders', {}, onResult );
    }

    getOrderStatus( order_id, client_secret, source, livemode, onResult ){
        this.doGetRequest('payments/order/' + order_id,
                {
                                client_secret:client_secret,
                                source: source,
                                livemode: livemode
                            },
                                onResult );
    }

    getAliPayRedirectUrl( dev_uuid, amount, onResult ){
        this.doRequest( 'payments/device/' + dev_uuid,
            {
                amount: amount * 100,
                payment_method: PAYMENT_METHOD_ALIPAY,
            },
            onResult
        );

    }

    submitCreditCardCharge(credit_card_token_id, dev_uuid, amount, onResult ){
        this.doRequest( 'payments/device/' + dev_uuid,
            {
                token_id:  credit_card_token_id,
                amount: amount * 100,
                payment_method: PAYMENT_METHOD_CREDIT_CARD,
            },
            onResult
            );
    }

    getPartnerStatus(onResult) {
        this.doGetRequest('payments/partner/status', {}, onResult);
    }
    submitPartnerRequest(onResult) {
        this.doRequest('payments/partner/application', {}, onResult);
    }

    createStripePartnerAccount(external_account_token_id, stripe_account_token_id, onResult ){
        this.doRequest( 'payments/partner/account',
            {
                stripe_account_token:  stripe_account_token_id,
                external_account_token:  external_account_token_id,
            },
            onResult
        );
    }

    getPartnerTransactions(agreement_id, onResult) {
        this.doGetRequest('payments/agreements/'+ agreement_id + '/transactions', {}, onResult);
    }

    getPartnerAgreements(onResult) {
        this.doGetRequest('payments/partner/agreements', {}, onResult);
    }

    getPartnersList(onResult) {
        this.doGetRequest('payments/admin/partners', {}, onResult);
    }

    submitPartnerApproval(partner_id, approved, onResult) {
        this.doRequest('payments/admin/partners/' + partner_id,
            {approved: approved},
            onResult,
            "PATCH");
    }

    getAgreementsList(onResult) {
        this.doGetRequest('payments/admin/agreements', {}, onResult);
    }

    createAgreement(agreement, onResult) {
        this.doRequest('payments/admin/agreements',
            agreement,
            onResult,
            "POST");
    }

    modifyAgreement(agreement, onResult) {
        this.doRequest('payments/admin/agreements/' + agreement.id,
            agreement,
            onResult,
            "PUT");

    }

    deleteAgreement(agreement_id, onResult) {
        this.doRequest('payments/admin/agreements/' + agreement_id,
            {},
            onResult,
            "DELETE");

    }
}


function withSimGps(WrappedComponent) {

    return class extends React.Component {
        constructor(props){
            super(props);
            const useLocalIfServer = false;
            let url;
            if ( useLocalIfServer ) {
                url = 'http://localhost:12346/Test';
            }else{
                url = params.SIM_GPS_API_URL;
            }

            // Must be wrapped with withAuthenticator HOC in order to have this.props.authData
            this.id_token = this.props.authData.signInUserSession.idToken.jwtToken;
            this.simGps = new SimGps(url, params.PENTOS_API_KEY, this.id_token);
        }

        render() {
            return  <WrappedComponent {...this.props} simGps={this.simGps} id_token={this.id_token}/>;
        }
    }
}


export default withSimGps;
